import { CONFIG } from './config'

export const VALIDGUESSES = [    
  'timadju',
  'aravac',
  'nimadju',
  'caucau',
  'mareka',
  'kemasi',
  'nakuya',
  'makaya',
  'payuan',
  'macaqu',
  'nanguaq',
  'sanguaq',
  'ayatua',
  'tjuruvu',
  'uqaljai',
  'ljemita',
  'pinaka',
  'namaya',
  'kamaya',
  'saqetju',
  'vurasi',
  'kiukai',
  'pairang',
  'patjara',
  'utubai',
  'mangtjez',
  'tjenglai',
  'kitulu',
  'semupu',
  'nemanga',
  'kuljelje',
  'vaquan',
  'palisi',
  'madjele',
  'kirimu',
  'kinacu',
  'katiaw',
  'tigami',
  'kisacu',
  'madrusa',
  'nekanga',
  'nikama',
  'sinzia',
  'taiwan',
  'nutiav',
  'kuisang',
  'qatjuvi',
  'saviki',
  'padjele',
  'madjulu',
  'malivu',
  'kivala',
  'pacunu',
  'izainu',
  'padain',
  'malada',
  'qepuan',
  'makuda',
  'nungida',
  'samaza',
  'tjianes',
  'kemuda',
  'tiaken',
  'pariuk',
  'sunciu',
  'palamu',
  'kemesa',
  'hakasi',
  'izuanga',
  'kemljang',
  'paveli',
  'tjenglay',
  'linalja',
  'nikina',
  'qapulu',
  'ljegean',
  'kisudju',
  'inianga',
  'mananga',
  'caquan',
  'tiamdju',
  'duduan',
  'kacuin',
  'masiaq',
  'mapida',
  'taidai',
  'maculju',
  'bukusi',
  'kasinu',
  'tjainan',
  'pidanga',
  'vencik',
  'cemavu',
  'cinavu',
  'tikama',
  'katiav',
  'venali',
  'kaukav',
  'siubai',
  'kumuing',
  'kimadju',
  'pasusu',
  'matjani',
  'paukuz',
  'saljinga',
  'tiribi',
  'pualjak',
  'namasi',
  'kemacu',
  'vineli',
  'bukesi',
  'timanga',
  'nutiaw',
  'tjekeza',
  'qecilu',
  'maculja',
  'ljasiak',
  'hikuki',
  'tikina',
  'niaken',
  'ljamljam',
  'sasequ',
  'lunbun',
  'maljama',
  'siqunu',
  'masusu',
  'senema',
  'zukuan',
  'navaik',
  'muqami',
  'temulu',
  'turaku',
  'tuaicu',
  'remasi',
  'vuciar',
  'masalu',
  'cengceng',
  'inayan',
  'kaiven',
  'inalap',
  'kivaqu',
  'tiamen',
  'zemian',
  'kiqaung',
  'veljvelj',
  'maleva',
  'maipuq',
  'manganga',
  'sakinu',
  'calinga',
  'paiwan',
  'masudju',
  'sinika',
  'vakela',
  'valanga',
  'daihiu',
  'dangdang',
  'zemaing',
  'muakai',
  'marivu',
  'gemalju',
  'tuazua',
  'raimai',
  'qemaung',
  'kinsan',
  'malupi',
  'kiumalj',
  'maumalj',
  'palaing',
  'qinljan',
  'ljautjia',
  'nguangua',
  'tjeqalja',
  'sukaka',
  'valjanga',
  'langpaw',
  'ljaqedi',
  'meqaca',
  'sinasi',
  'venala',
  'ljegeai',
  'qaqivu',
  'zemuga',
  'acaaca',
  'numaya',
  'kiadjuq',
  'anasui',
  'uqaljay',
  'itjumaq',
  'batili',
  'kuljkulj',
  'benuru',
  "'ciuru",
  'taiciu',
  'lanpaw',
  'tjimadju',
  'rinasi',
  'makelu',
  'mintjus',
  'caljisi',
  'kisusu',
  'casavu',
  'rungrung',
  'cemulju',
  'sivaik',
  'semusu',
  'cinusu',
  'uljatjen',
  'kinasi',
  'pecungu',
  'minseg',
  'langpav',
  'rusuku',
  'demudu',
  'kangida',
  'kudain',
  'medjama',
  'makuya',
  'gacalju',
  'ljemama',
  'pagalju',
  'vicuka',
  'kiayan',
  'nekanu',
  'tjartjar',
  'manguaq',
  'tjaqali',
  'ljavaus',
  'maljian',
  'kanipi',
  'pizuau',
  'suvuvu',
  'tjaizua',
  'kenama',
  'qavain',
  'makesa',
  'padjalji',
  'kiukay',
  'tulaku',
  'sikuda',
  'kivali',
  'kusini',
  'kulila',
  'laupan',
  'ljezaya',
  'zitting',
  'sengseng',
  'capain',
  'singlit',
  'ljaluing',
  'nivuvu',
  'ljavljav',
  'taitan',
  'matega',
  'marusa',
  'siljian',
  'mauraq',
  'papius',
  'tinnaw',
  'migani',
  'sibiru',
  'nikaka',
  'qemuma',
  'tatiav',
  'vuvuan',
  'tjuqalja',
  'ragrag',
  'remuqu',
  'valjulu',
  'zemala',
  'aiyanga',
  'nataed',
  'iladjan',
  'kinljang',
  'alapen',
  'angadan',
  'matjelu',
  'aljungic',
  'maljipa',
  'puamin',
  'madele',
  'ljaljungu',
  'ruveca',
  'vavain',
  'mamave',
  'siasing',
  'caitav',
  'ulaljuc',
  'calavi',
  'calisi',
  'saqetu',
  'cemapa',
  'sinkiu',
  'ciupan',
  'icasav',
  'qemepu',
  'taguan',
  'cavuin',
  'aseman',
  'cemual',
  "'inuli",
  'cemusu',
  'cemvak',
  'cemviq',
  'sinvalj',
  'tevuta',
  'pinpung',
  'selaing',
  'ivavaw',
  'maqilji',
  'kicual',
  'utubay',
  'cungtung',
  'cuntung',
  'mangilu',
  'maligu',
  'sualjak',
  'ljiadet',
  'masepu',
  'gungkang',
  'rivuan',
  'madudu',
  'sinane',
  'tjinaki',
  'maulav',
  'mapulju',
  'siveli',
  'ljegeay',
  'zaisang',
  'sevalji',
  'menaca',
  'gingging',
  'mayanga',
  'singkiu',
  'piapia',
  'hantai',
  'inalang',
  'mavaik',
  'remuvu',
  'saluan',
  'inumalj',
  'pilima',
  'isisiu',
  'itungan',
  'sinbun',
  'kakara',
  'lingadja',
  'melava',
  'maruqu',
  'kemalja',
  'tisagi',
  'tjamaku',
  'kasusu',
  'kiraqa',
  'kiveli',
  'mangada',
  'kemuang',
  'kesain',
  'nimatju',
  'sinara',
  'samulja',
  'kiqilja',
  'kisasa',
  'pininu',
  'vaikan',
  'pukaui',
  'sikesa',
  'kuacui',
  'kudrayu',
  'qulipu',
  'qemuang',
  'kulimu',
  'ljeminga',
  'ruvaik',
  'sakuya',
  'malaing',
  'mazeli',
  'sialap',
  'lemisi',
  'caucua',
  'likisi',
  'tjanasi',
  'valain',
  'ljemuku',
  'arevac',
  'ljaljiga',
  'pucungu',
  'ljemaui',
  'ljemulju',
  'pimaca',
  'kumalji',
  'kuljius',
  'pakata',
  'samalji',
  'mapualj',
  'mananu',
  'semuap',
  'ljautia',
  'masasa',
  'masetu',
  'sedjalu',
  'zelian',
  'nuaicu',
  'maurag',
  'mavetu',
  'menguaq',
  'minqut',
  'minasi',
  'qalici',
  'mirava',
  'pitaku',
  'niamen',
  'kingidju',
  'ayaken',
  'semila',
  'nuazua',
  'kuljilji',
  'paulan',
  'siuljai',
  'lingdjelj',
  'piququ',
  'qalian',
  'caitau',
  'pivaik',
  'puisiq',
  'muakay',
  'qemalu',
  'qinati',
  'qauzung',
  'tjuzuma',
  'qemreng',
  'seqalja',
  'tianes',
  'tjaimua',
  'talidu',
  'tjaljtjalj',
  'vinalji',
  'vintjang',
  'venate',
  'tapulu',
  'mangtez',
  'unuunu',
  'udjidjilj',
  'mamaza',
  'vaikai',
  'mavana',
  'kaucung',
  'kautie',
  'kukuan',
  'pingtung',
  'taivan',
  'papaka',
  'abunai',
  'adjuqan',
  'inadjuq',
  'lampau',
  'nimacu',
  'kimaya',
  'rualjak',
  'hanciu',
  'ruangalj',
  'puarai',
  'ariari',
  'baiking',
  'baqbaq',
  'barasu',
  'kuaisu',
  'kemali',
  'pinpong',
  'makata',
  'mabiri',
  'rumazi',
  'bungbung',
  'buntan',
  'buqbuq',
  'qavuan',
  'ruburu',
  'busbus',
  'masaku',
  'secaca',
  'cacana',
  'cemaca',
  'tjasipu',
  'tjakava',
  'temangu',
  'cemadja',
  'pacayu',
  'caikui',
  'cemaing',
  'djaungen',
  'ipuqen',
  'sikkiu',
  'capelju',
  'nanema',
  'caqcaq',
  'pecaqi',
  'pazaing',
  'kivasa',
  'kicauv',
  'cemauv',
  'cembuk',
  'cemged',
  'cekcek',
  'sikici',
  'cangkim',
  'namare',
  'celaku',
  'cemlak',
  'sasupu',
  'saqedju',
  'macelu',
  'cemelu',
  'sedjaljp',
  'uljasun',
  'cempalj',
  'cemian',
  'cemingu',
  'kemasa',
  'lumljak',
  'cempis',
  'cemepu',
  'cemqadj',
  'macenu',
  'liadet',
  'cemuli',
  'masatja',
  'cemulja',
  'cemvud',
  'cemvulj',
  'scevung',
  'ljamain',
  'avangalj',
  'cinpis',
  'inuinu',
  'secevng',
  'idjalan',
  'sasingi',
  'cikelu',
  'qemati',
  'macingu',
  'cinulju',
  'qaunip',
  'tjacuai',
  'caingan',
  'suqali',
  'saulilj',
  'cugiki',
  'cukunu',
  'kiculja',
  'culjain',
  'cungiri',
  'taiwang',
  'cuzuku',
  'alisang',
  'pusepi',
  'adengec',
  'djaudjaw',
  'liljuas',
  'djadjasu',
  'djakucu',
  'qecapu',
  'akisun',
  'padjama',
  'djapesu',
  'adjaqan',
  'djemaulj',
  'kuangen',
  'pidjanga',
  'kualjak',
  'akeman',
  'djekuac',
  'djemeli',
  'djemaung',
  'daikung',
  'tjuluvu',
  'djemulu',
  'kusuli',
  'djivicu',
  'maqati',
  'mapana',
  'magadu',
  'djumulju',
  'qiusia',
  'sequan',
  'draqili',
  'paljilji',
  'dresdres',
  'kugacu',
  'gugacu',
  'sangacu',
  'sigacu',
  'nigacu',
  'gaduan',
  'igakku',
  'kacaun',
  'galasu',
  'zuanan',
  'segalju',
  'galugu',
  'gaugaw',
  'gemcel',
  'tjemelju',
  'saqivu',
  'gemugu',
  'gemula',
  'paljemk',
  'kigidi',
  'vasasa',
  'ciusing',
  'drinasi',
  'ginula',
  'giusia',
  'gucalu',
  'gucguc',
  'gulain',
  'magula',
  'magulu',
  'piqimi',
  'gumecu',
  'vengetju',
  'nitjama',
  'hadasi',
  'naluan',
  'haiyang',
  'hanako',
  'kitima',
  'hicuzi',
  'kingiin',
  'huangti',
  'hukuku',
  'pahusu',
  'icibang',
  'lemigu',
  'tevela',
  'intucu',
  'tjaizing',
  'sipaka',
  'isangas',
  'kaitan',
  'italadj',
  'venric',
  'karari',
  'paitung',
  'kacian',
  'pakacu',
  'sikacu',
  'rukacu',
  'seisiu',
  'kaiciu',
  'lukuzi',
  'pakaiv',
  'semane',
  'kakuzu',
  'pukala',
  'temqic',
  'kaljadju',
  'kaljalju',
  'kaljava',
  'vevean',
  'kangkang',
  'kanguhu',
  'caucus',
  'litjuku',
  'karangu',
  'kasuga',
  'lanpav',
  'kemaus',
  'sikaus',
  'kemava',
  'kavara',
  'qevadu',
  'kavicu',
  'piliqu',
  'kawkuy',
  'valasa',
  'kazelju',
  'kembung',
  'kemeli',
  'hulicu',
  'kemisi',
  'kemulji',
  'kemuya',
  'kinesa',
  'kiketu',
  'kiabic',
  'pukiam',
  'kiaping',
  'kicaing',
  'kilava',
  'kiljaung',
  'sakenge',
  'kimanu',
  'kasuni',
  'kinciu',
  'kingking',
  'sasuyu',
  'mekeri',
  'kinula',
  'semuav',
  'kinulji',
  'kipaiz',
  'lampav',
  'kipasa',
  'semasa',
  'patjelja',
  'kiqepu',
  'kiquca',
  'kidraqa',
  'kiruku',
  'puljuan',
  'kisiaq',
  'rinuvu',
  'rinari',
  'kiunang',
  'kukiam',
  'kivetu',
  'kizaqu',
  'kuazua',
  'kuabar',
  'kuangka',
  'pakucu',
  'akudrav',
  'kukugu',
  'pikula',
  'makulji',
  'kunring',
  'kuskus',
  'padriur',
  'kustau',
  'kususu',
  'jakawu',
  'pukuya',
  'tjakuya',
  'kuyain',
  'ljekuya',
  'lemaing',
  'pusequ',
  'laliqu',
  'lemalja',
  'tekelu',
  'kiqeci',
  'sekezi',
  'selamu',
  'semnay',
  'rualap',
  'pavali',
  'iziycu',
  'ljelauz',
  'akapaz',
  'muledje',
  'linedje',
  'ivavav',
  'tatiaw',
  'lemima',
  'sauljai',
  'lemqes',
  'lemuka',
  'lemupi',
  'levecu',
  'likzalj',
  'ilikuz',
  'sanaku',
  'linima',
  'liplip',
  'lipuru',
  'cinvak',
  'lucluc',
  'maluka',
  'pangtjer',
  'vuciulj',
  'temzeng',
  'luvadu',
  'adjalan',
  'tjasika',
  'sinvai',
  'mavanu',
  'ljaluai',
  'djamain',
  'ljinama',
  'paljaung',
  'maljaung',
  'kaljipa',
  'ljavilu',
  'sinipu',
  'masupu',
  'ljemiak',
  'ljemiqu',
  'puitau',
  'ljemiug',
  'ljiabar',
  'ljinaui',
  'patulu',
  'ljinulju',
  'ljiquin',
  'kitjima',
  'djumrac',
  'minaca',
  'madjaung',
  'piliqi',
  'malalja',
  'menali',
  'qinalja',
  'kumuin',
  'dingwan',
  'mapedi',
  'sisupu',
  'tikaka',
  'kulima',
  'maqepu',
  'maquang',
  'maquca',
  'maqumu',
  'maquyu',
  'langdaw',
  'marengc',
  'marial',
  'marimu',
  'pulami',
  'kipaki',
  'tenglai',
  'masila',
  'masisi',
  'nacuai',
  'kanabu',
  'setjere',
  'matulu',
  'maudalj',
  'mauram',
  'maurem',
  'liavan',
  'maveca',
  'aljakai',
  'mayaqa',
  'dedetu',
  'tutuin',
  'nuaken',
  'mesuak',
  'matuin',
  'aquvalj',
  'anemang',
  'misepi',
  'mitjezu',
  'makagu',
  'quyulju',
  'munqez',
  'mupupu',
  'mutjmutj',
  'raumalj',
  'pesema',
  'vintang',
  'lupian',
  'punema',
  'quvali',
  'ngilngil',
  'ngisngis',
  'bakuci',
  'vavaua',
  'tucccu',
  "pa'iga",
  'paivatj',
  'papaiz',
  'liavang',
  'pairan',
  'pakiav',
  'pigadu',
  'sikuki',
  'palpal',
  'pakani',
  'tjepana',
  'sinljec',
  'tataqu',
  'paqaung',
  'paqeci',
  'akemac',
  'paqeqe',
  'paqiat',
  'pinasa',
  'pasupu',
  'ruvuin',
  'pasiav',
  "'unting",
  'sinding',
  'pausev',
  'pausui',
  'pautez',
  'pavaik',
  'raceve',
  'pailjus',
  'nuaking',
  'pinedi',
  'pensis',
  'inciyu',
  'penualj',
  'limanga',
  'garasu',
  'tinangz',
  'piumaq',
  'piyuma',
  'kapudju',
  'siaven',
  'sapulju',
  'pupulju',
  'puqavu',
  'qemceng',
  'pumaya',
  'puqentj',
  'puqulu',
  'puquma',
  'pususu',
  'ayatya',
  'puyuma',
  'tjiamdju',
  'tjaqaca',
  'siljaung',
  'culjuan',
  'mangdjez',
  'qaluin',
  'qaluvu',
  'qamudru',
  'qamuru',
  'sinzam',
  'qangsel',
  'qanglic',
  'matjatju',
  'satjezu',
  'qarutu',
  'qaselu',
  'qatian',
  'kinanga',
  'qatjupu',
  'tjuaqau',
  'tuaqau',
  'kuqalji',
  'akinsa',
  'sakucu',
  'kasiav',
  'qemayu',
  'sengseg',
  'qeciin',
  'lagavi',
  'qemluz',
  'qememu',
  'taudan',
  'qemili',
  'qemilja',
  'qemsang',
  'qinemu',
  'qemumu',
  'qemuqu',
  'qemuyu',
  'pinatja',
  'qepuin',
  'kumanu',
  'qiladju',
  'qiljain',
  'qinilja',
  'vateqi',
  'temljar',
  'nguaqan',
  'senavi',
  'tjanusu',
  'qubqub',
  'qucquc',
  'quljemu',
  'nukalja',
  'qungcui',
  'qunvulj',
  'qusulu',
  'zengrur',
  'quyuan',
  'kaukau',
  'tilipi',
  'kavaik',
  'dremasi',
  'rinava',
  'remsung',
  'rimuan',
  'rinuqu',
  'rucruc',
  'rugrug',
  'varalji',
  'sadjsadj',
  'miauli',
  'saljiuk',
  'manaku',
  'samiang',
  'manasi',
  'vencilj',
  'vingtang',
  'kilaing',
  'timadu',
  'sauram',
  'sicapa',
  'sazuau',
  'pitiru',
  'sekazu',
  'sekezu',
  'semkez',
  'cemvelj',
  'seliap',
  'valengi',
  'seljecu',
  'ciqave',
  'semema',
  'semequ',
  'tilivi',
  'semiaq',
  'semiav',
  'semnai',
  'pimaza',
  'sinvec',
  'siakai',
  'namsan',
  'siaqan',
  'tjasini',
  'qayamu',
  'sinupu',
  'saljuang',
  'sivala',
  'ikaken',
  'kaipuq',
  'sugaku',
  'ljagadu',
  'kemucu',
  'tuabal',
  'sanaka',
  'sanguan',
  'temapi',
  'taukua',
  'pidjuai',
  'kaizua',
  'kaidang',
  'teceku',
  'temega',
  'ljeteku',
  'tuania',
  'buruin',
  'tjemani',
  'tuluqu',
  'aneman',
  'kacuyi',
  'qudjanlj',
  'tjacupu',
  'pinapu',
  'tjaikui',
  'pulima',
  'lemuni',
  'tjaumalj',
  'tjemaza',
  'temkel',
  'ljupetju',
  'tjezuau',
  'tjingtjing',
  'tjungtjung',
  'tjuqtjuq',
  'tjuvtjuv',
  'udungku',
  'wanjin',
  'umaljen',
  'untingu',
  'niaiza',
  'vakaba',
  'kusika',
  'ljailjai',
  'valjias',
  'qacilu',
  'vecuan',
  'venljatj',
  'venljeng',
  'veljiut',
  'venava',
  'veneve',
  'lanpau',
  'viduat',
  'viljugu',
  'viniqu',
  'viqviq',
  'valian',
  'vucelje',
  'vucvuc',
  'vukide',
  'sivali',
  'ciuming',
  'yakiyu',
  'seikai',
  'kainua',
  'yisuan',
  'casiru',
  'sabtiq',
  'zangalu',
  'lailai',
  'tivuvu',
  'talima',
  'piqulu',
  'zemaqu',
  'sisiyu',
  'tjasane',
  'zazavu',
  'zemzem',
  'ziuding',
  "'ausua",
  'udidilj',
  'makadra',
  'gacalji',
  'zingrur',
  'niauma',
  'matjuma',
  'sacealj',
  'minaup',
  'pinaup',
  'tiaima',
  'napelju',
  'turuvu',
  'ljaljeel',
  'padjulu',
  'nupita',
  'tukian',
  'ciurav',
  'pacuni',
  'savida',
  'cavuan',
  'tjeljuqi',
  'nukana',
  'tankau',
  'veneli',
  'cinapa',
  'djeljuai',
  'biuying',
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
